import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'result-twog-ko-pl-table',
  templateUrl: 'result-twog-ko-pl-table.html',
})
export class ResultTwoGKoPlTablePage {
  gamePlanList: IGamePlan[] = [];

  @Input() plan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  constructor(
    private navParams: NavParams
  ) { }

  onEditTeam(i: number, j: number) {
    this.onEdit.emit({ i: i, j: j, graph: true });
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-twog-ko-pl/map-game-table/result-twog-ko-pl-table.ts